import { useLocale } from "../../../hooks/useLocale";
import { msg } from "../../../locales/translate";
import { HBox, VBox } from "@ui/box/Box";
import Button from "@ui/button/Button";
import Spacer from "@ui/spacer/Spacer";
import { Rows } from "@ui/table/Rows";
import { useEffect, useState } from "react";
import { GD } from "src/GD";
import { useRouter } from "src/services/Router";
import { notify } from "../../../tools/notify";
import { IAcquirerChannel } from "src/types/types";
import { S_ADD_CHANNEL_POPUP } from "src/view/popup/AddChannelPopup";
import { S_ADD_TERMINAL_POPUP } from "src/view/popup/AddTerminalPopup";
import { S_CONFIRM } from "src/view/popup/general/ConfirmDialog";

export interface IMerchantTerminalChannelsProps {
	merchantId: number;
	clientId: number;
	terminalId?: number;
	internal?: boolean;
}

export const MerchantTerminalChannels = ({ merchantId, clientId, internal, terminalId }: IMerchantTerminalChannelsProps) => {
	useLocale();
	const router = useRouter();

	//!TODO: busy;
	//const [channels, _channelsBusy] = GD.B_MERCHANT_ATTACHED_CHANNELS.use({ merchantID: merchantId, terminalId: terminalId }, undefined, []);

	const [channels, setChannels] = useState<IAPIResponse<IAcquirerChannel[]>>();

	useEffect(() => {
		loadData();
	}, []);

	const loadData = async () => {
		const res = await GD.REQ_MERCHANT_ATTACHED_CHANNELS.request({ merchantID: merchantId, terminalId: terminalId });
		setChannels(res);
	};

	const onAdd = async () => {
		const attachedTerminals = await GD.B_MERCHANT_ATTACHED_TERMINALS.execute({ merchantID: merchantId });

		if (attachedTerminals?.data) {
			if (attachedTerminals.data.length > 0) {
				S_ADD_CHANNEL_POPUP.invoke({
					merchantID: merchantId,
					onSuccess: () => {
						loadData();
					},
				});
			} else {
				S_CONFIRM.invoke({
					message: msg("thereAreNoTerminalsInTheMerchantDoYouWantToAddOne"),
					reject: "Cancel",
					confirm: msg("addTerminal"),
					onResult: (val: "confirm" | "reject") => {
						if (val === "confirm") {
							S_ADD_TERMINAL_POPUP.invoke({
								merchantID: merchantId,
								onSuccess: () => {
									GD.B_MERCHANT_ATTACHED_TERMINALS.execute({
										merchantID: merchantId,
									});
								},
							});
						}
					},
				});
			}
		}
	};

	const removeChannel = async (id: number) => {
		//!TODO: loader;
		S_CONFIRM.invoke({
			message: msg("areYouSure"),
			reject: "Cancel",
			onResult: (val: "confirm" | "reject") => {
				if (val === "confirm") {
					onChannelRemoveConfirm(id);
				}
			},
		});
	};

	const onChannelRemoveConfirm = async (id: number) => {
		//!TODO: loader;
		const res = await GD.REQ_MERCHANT_REMOVE_CHANNEL.request({
			channelID: id,
			merchantID: merchantId,
		});
		//!TODO:;
		if (res) {
			notify.info(msg("removed"));
		}
	};

	return (
		<VBox gap="10px">
			{merchantId !== 0 && (
				<HBox>
					<Spacer grow />
					<Button onClick={onAdd} title={msg("addChannel_ad6357a1")} variant="primarySmall" />
				</HBox>
			)}

			<VBox gap="20px">
				<Rows
					itemType={"channel"}
					//	order={["__itemType", "status", "title", "terminal", "__actions"]}
					order={["__itemType", "status", "title", "__actions"]}
					internal={internal}
					// data={channelsLocal.map(m => {
					// 	return {
					// 		...m,
					// 		terminal: terminals?.data?.find(t => t.id === m.terminal_id)?.name,
					// 	};
					// })}
					data={channels?.data ?? []}
					onClick={(row: IAcquirerChannel & { terminal?: string }) => {
						router.navigate("merchantchannel", {
							chid: row.link_id + "",
							mid: merchantId + "",
							cid: clientId + "",
						});
					}}
					menu={[
						{
							title: msg("remove"),
							id: "remove",
						},
					]}
					onMenuClick={(id, row, _rowID) => {
						if (id === "remove") {
							removeChannel(row.id);
						}
					}}
				/>
			</VBox>
		</VBox>
	);
};
